import { Component, Inject } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef
} from "@angular/material/dialog";
import { MasterDataDataService } from "src/app/share/data-service/master-data.data.service";
import { AlertService } from "src/app/share/service/alert.service";
import { OrderDataService } from "../../data-service/order-data.service";
import { RequestStatusDialogComponent } from "src/app/car-insurance/ui/request-status-dialog/request-status-dialog.component";

@Component({
    selector: "app-car-variant-dialog",
    templateUrl: "./car-variant-dialog.component.html",
    styleUrls: ["./car-variant-dialog.component.scss"],
    standalone: false
})
export class CarVariantDialogComponent {
	linkId: string;
	carData: {
		model: string;
		make: string;
		year: number;
		vehicle: string;
	};
	carVars: { id: string; vehicle: string }[];
	selectedCar: { id: string; vehicle: string } = null;
	confirmChanges: boolean;
	editCarModel: boolean = true;
	isMotorcycle = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<CarVariantDialogComponent>,
		private masterDataDataService: MasterDataDataService,
		private orderDataService: OrderDataService,
		private alertService: AlertService,
		private dialog: MatDialog
	) {
		this.linkId = this.data.linkId;
		this.carData = this.data.requestData;
		this.confirmChanges = false;
		this.isMotorcycle = this.data.requestData.vehicleType == "Motorcycle" ? true : false;
	}

	editCarVariant() {
		let searchText: string = this.carData.model + " " + this.carData.year;
		// let searchText: string = this.carData.model + " 2021";

		// console.log("Query model+year =", searchText);
		this.masterDataDataService
			.getVehicleModelListing(20, 1, searchText, 1, "", this.carData.make)
			.subscribe({
				next: (x) => {
					if (x.length === 0) {
						this.alertService.openSnackBar(this.isMotorcycle ? "No motorcycle variant found!" : "No car variant found!");
						this.editCarModel = false;
					} else {
						this.carVars = x;
					}
				},
				error: (err) => {
					this.alertService.openSnackBar("Error:", err);
				},
			});
	}

	proceedQuotation() {
		this.dialogRef.close({ data: true });
	}

	saveChanges(selectedCar: any) {
		this.orderDataService
			.editCarVariant(this.linkId, selectedCar.id)
			.subscribe({
				next: (x) => {
					// confirm changes layout
					this.confirmChanges = true;
				},
				error: (err) => {
					if (err.error === "Request for " + this.data.requestData.vehicleNo + " is already IN PROGRESS.") {
						this.dialog.open(RequestStatusDialogComponent, {
							panelClass: "no-padding-border-radius-dialog",
							data: {
								vehicleNo: this.data.requestData.vehicleNo,
								email: this.data.requestData.email,
								type: "Dup_Quote"
							}
						});
					}
					else {
						this.alertService.openSnackBar(
							"Failed sending edit car variant request",
						);
					}

					this.dialogRef.close();
				},
			});
	}

	onCarSelectChange(event: any): void {
		this.selectedCar = { id: event.value.id, vehicle: event.value.vehicle };
	}
}
